<template>
    <form v-on:submit.prevent="prevent" class="py-12"> 
        <v-slide-x-transition>
            <v-card class="mx-auto my-3" max-width="768" :loading="loading">
                <v-card-title>
                 <!-- {{ $t('register.steps.company.title') }} -->
                </v-card-title>
                <v-card-text>
                   <v-row>
                        <v-col cols="12" md="6" sm="12">
                            <v-text-field v-model="form.companyDocument" :loading="checkerLoading.document" :error-messages="companyDocumentErrors"  v-mask="documentMask" :label="`${assets.countries[country].companyDocument}*`" required
                            @input="v$.form.companyDocument.$touch()" @blur="v$.form.companyDocument.$touch()">
                            <v-icon slot="append" color="green" v-if="available.document === true">
                              mdi-check
                          </v-icon>
                          </v-text-field>
                        </v-col>

                        
                        <v-col cols="12" md="6" sm="12">
                            <v-text-field v-model="form.displayNameSS" label="Display name" ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" sm="12">
                            <v-text-field v-model="form.companyName" :error-messages="companyNameErrors" :label="$t('register.steps.company.form.companyName.label')" required
                                @input="v$.form.companyName.$touch()" @blur="v$.form.companyName.$touch()"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" sm="12">
                            <v-text-field v-if="switchForm" v-model="form.displayName" :label="$t('register.steps.company.form.displayName.label')" ></v-text-field>
                            <v-text-field v-else v-model="form.displayName" :error-messages="displayNameErrors" :label="`${$t('register.steps.company.form.displayName.label')}*`" required
                            @input="v$.form.displayName.$touch()" @blur="v$.form.displayName.$touch()"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-title><div v-html="$t('register.steps.company.address')"></div></v-card-title>
                <v-card-text>
                    <v-row>
          
                        <v-col cols="12" md="5" sm="12">
                          <v-text-field
                          :label="$t('register.steps.company.form.zipcode.label')" 
                            v-model="address.zipCode"
                            @change="changeZipCode()"
                            @blur="changeZipCode()"
                            required
                            v-mask="zipCodeMask"
                            :error-messages="zipCodeErrors"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="7" sm="12">
                          <v-text-field
                          :label="$t('register.steps.company.form.street.label')" 
                            v-model="address.street"
                            @change="v$.address.street.$touch()"
                            @blur="v$.address.street.$touch()"
                            required
                            counter="50"
                            :error-messages="streetErrors"
                          ></v-text-field>
                        </v-col>
                        <v-col md="2" sm="6">
                          <v-text-field
                          :label="$t('register.steps.company.form.number.label')" 
                            v-model="address.number"
                            @change="v$.address.number.$touch()"
                            @blur="v$.address.number.$touch()"
                            required
                            counter="10"
                            :error-messages="numberErrors"
                          ></v-text-field>
                        </v-col>
                        <v-col md="3" sm="6">
                          <v-text-field
                          :label="$t('register.steps.company.form.complement.label')" 
                            v-model="address.complement"
                            @change="v$.address.complement.$touch()"
                            @blur="v$.address.complement.$touch()"
                            counter="20"
                            :error-messages="complementErrors"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="4" sm="12">
                          <v-text-field
                          :label="$t('register.steps.company.form.district.label')" 
                            v-model="address.district"
                            @change="v$.address.district.$touch()"
                            @blur="v$.address.district.$touch()"
                            required
                            counter="50"
                            :error-messages="districtErrors"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                          <v-text-field
                          :label="$t('register.steps.company.form.city.label')" 
                            v-model="address.city"
                            @change="v$.address.city.$touch()"
                            @blur="v$.address.city.$touch()"
                            required
                            counter="50"
                            :error-messages="cityErrors"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                          <v-select v-if="country == 0"
                          :label="$t('register.steps.company.form.state.label')" 
                            v-model="address.state"
                            @change="v$.address.state.$touch()"
                            @blur="v$.address.state.$touch()"
                            required
                            :items="states"
                            item-text="label"
                            item-value="state"
                            :error-messages="stateErrors"
                          ></v-select>
                          <v-text-field
                          v-else
                          :label="$t('register.steps.company.form.state.label')"
                          v-model="address.state"
                            @change="v$.address.state.$touch()"
                            @blur="v$.address.state.$touch()"
                            required
                            counter="50"
                            :error-messages="stateErrors"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6" sm="12" v-show="false">
                          <v-text-field
                            v-model="form.phone"
                            :label="$t('register.steps.company.form.phone.label')"
                            :error-messages="phoneErrors"
                            :placeholder="phonePlaceholder"
                            v-mask="phoneMask"
                            required
                            @input="v$.form.phone.$touch()"
                            @blur="v$.form.phone.$touch()"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-end py-3">
                    <div class="d-flex justify-end align-center py-2" style="width: 100%">
                        <v-btn color="white" elevation="0" type="button" class="mr-2" @click="$emit('change-step', 1)"><v-icon class="mr-6" small>mdi-arrow-left</v-icon> {{ $t('register.steps.buttons.back') }}</v-btn>
                        <v-btn class="mr-2 white--text" color="green" elevation="0" type="button"
                        :loading="processing"
                            :disabled="(v$.$invalid && v$.$errors.length > 0) || (v$.$dirty && v$.$invalid)" @click="submit()">
                            {{ $t('register.steps.buttons.next') }} <v-icon class="ml-6" small>mdi-arrow-right</v-icon>
                        </v-btn>
                    </div>
                </v-card-actions>
               
            </v-card>
        </v-slide-x-transition>
    </form>
</template>
<script>
import axios from 'axios'
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength} from '@vuelidate/validators'
import validations from '@/plugins/validations'
// import RegisterAddress from './RegisterAddress.vue'
const isValidPeruRUC = (value) => validations.isValidPeruRUC(value)
export default {
    setup() {
        return { v$: useVuelidate() };
    },
    data: () => ({
        processing: false,
        loading: false,
        checkerLoading: {
            document: false
        },
        checkerTimeout: {
            document: null
        },
        available: {
            document: null
        },
        form: {
            companyName: "",
            displayName: "",
            companyDocument: "",
            displayNameSS: "",
            phone: "",
        },
        switchForm:'',
        address: {
        label: "",
        street: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        zipCode: "",
        contactTypeId: 1,
        country: "Brasil",
      },
      errors: {
            document: [],
        },
      states: [
        {
          state: "AC",
          label: "Acre",
        },
        {
          state: "AL",
          label: "Alagoas",
        },
        {
          state: "AM",
          label: "Amazonas",
        },
        {
          state: "AP",
          label: "Amapá",
        },
        {
          state: "BA",
          label: "Bahia",
        },
        {
          state: "CE",
          label: "Ceará",
        },
        {
          state: "DF",
          label: "Distrito Federal",
        },
        {
          state: "ES",
          label: "Espírito Santo",
        },
        {
          state: "GO",
          label: "Goiás",
        },
        {
          state: "MA",
          label: "Maranhão",
        },
        {
          state: "MT",
          label: "Mato Grosso",
        },
        {
          state: "MS",
          label: "Mato Grosso do Sul",
        },
        {
          state: "MG",
          label: "Minas Gerais",
        },
        {
          state: "PA",
          label: "Pará",
        },
        {
          state: "PB",
          label: "Paraíba",
        },
        {
          state: "PR",
          label: "Paraná",
        },
        {
          state: "PE",
          label: "Pernambuco",
        },
        {
          state: "PI",
          label: "Piauí",
        },
        {
          state: "RJ",
          label: "Rio de Janeiro",
        },
        {
          state: "RN",
          label: "Rio Grande do Norte",
        },
        {
          state: "RS",
          label: "Rio Grande do Sul",
        },
        {
          state: "RO",
          label: "Rondônia",
        },
        {
          state: "RR",
          label: "Roraima",
        },
        {
          state: "SC",
          label: "Santa Catarina",
        },
        {
          state: "SP",
          label: "São Paulo",
        },
        {
          state: "SE",
          label: "Sergipe",
        },
        {
          state: "TO",
          label: "Tocantins",
        },
      ],
    }),
    props: {
        assets: Object,
        country: Number,
        hash: String,
        userPhone: { type: String, default: "" }
    },
    validations() {
        const validationsList = {
            form: {
                companyName: { required, minLength: minLength(3) },
              //  displayName: { required, minLength: minLength(2) },
                companyDocument: { required },
                phone: { required, minLength: minLength(this.assets.countries[this.country].phoneMinLength) }
            },
            address: {
                street: { required, maxLength: maxLength(50) },
                number: { required, maxLength: maxLength(10) },
                complement: { maxLength: maxLength(20) },
                district: { required, maxLength: maxLength(50) },
                city: { required, maxLength: maxLength(50) },
                state: { required, maxLength: maxLength(50) },
                zipCode: { required, minLength: minLength(this.assets.countries[this.country].zipCodeMask.length), maxLength: maxLength(this.assets.countries[this.country].zipCodeMask.length) },
            },
        };
        if(this.assets.countries[this.country].code == 'PER'){
          
          validationsList.form.companyDocument.validFormat = isValidPeruRUC
        }
        if(this.switchForm){
          delete validationsList.form.displayName
        }

        return validationsList
    },
    mounted()
    {
      this.switchForm = this.$route.params.p ? this.$route.params.p: ""
      if (this.userPhone) this.form.phone = this.userPhone
    } ,
   computed: {
        streetErrors() {
      const errors = [];
      if (!this.v$.address.street.$dirty) return errors;
      this.v$.address.street.maxLength.$invalid &&
        errors.push(this.$t('register.steps.company.form.street.errors.maxLength', {count: 50}));
      this.v$.address.street.required.$invalid && errors.push(this.$t('register.steps.company.form.street.errors.required'));
      return errors;
    },
    numberErrors() {
      const errors = [];
      if (!this.v$.address.number.$dirty) return errors;
      this.v$.address.number.maxLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.number.errors.maxLength', {count: 10}));
      this.v$.address.number.required.$invalid && errors.push(this.$t('register.steps.company.form.number.errors.required'));
      return errors;
    },
    complementErrors() {
      const errors = [];
      if (!this.v$.address.complement.$dirty) return errors;
      this.v$.address.complement.maxLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.complement.errors.maxLength', {count: 20}));
      return errors;
    },
    districtErrors() {
      const errors = [];
      if (!this.v$.address.district.$dirty) return errors;
      this.v$.address.district.maxLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.district.errors.maxLength', {count: 50}));
      this.v$.address.district.required.$invalid && errors.push(this.$t('register.steps.company.form.district.errors.required'));
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.v$.address.city.$dirty) return errors;
      this.v$.address.city.maxLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.city.errors.maxLength', {count: 50}));
      this.v$.address.city.required.$invalid && errors.push(this.$t('register.steps.company.form.city.errors.required'));
      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.v$.address.state.$dirty) return errors;
      this.v$.address.state.maxLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.state.errors.maxLength', {count: 50}));
      this.v$.address.state.required.$invalid && errors.push(this.$t('register.steps.company.form.state.errors.required'));
      return errors;
    },
    zipCodeErrors() {
      const errors = [];
      if (!this.v$.address.zipCode.$dirty) return errors;
      this.v$.address.zipCode.maxLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.zipcode.errors.maxLength'))
      this.v$.address.zipCode.minLength.$invalid &&
      errors.push(this.$t('register.steps.company.form.zipcode.errors.minLength'))
      this.v$.address.zipCode.required.$invalid && errors.push(this.$t('register.steps.company.form.zipcode.errors.required'))
      return errors;
    },
        phoneMask() {
            const result = this.assets.countries[this.country].phoneMasks;
            if (this.assets.countries[this.country].code == 'PER' && this.form.phone[4] == 1) {
                return "+51 # ### ## ##";
            }
            return result;
        },
        phonePlaceholder(){
            return this.assets.countries[this.country].phonePlaceholder
        },
        documentMask() {
            const result = this.assets.countries[this.country].companyDocumentMask;
            return result;
        },
        zipCodeMask(){
            const result = this.assets.countries[this.country].zipCodeMask
            return result
        },
        companyNameErrors() {
            const errors = [];
            if (!this.v$.form.companyName.$dirty)
                return errors;
            this.v$.form.companyName.minLength.$invalid && errors.push(this.$t('register.steps.company.form.companyName.errors.minLength', {count: 3}))
            this.v$.form.companyName.required.$invalid && errors.push(this.$t('register.steps.company.form.companyName.errors.required'))
            return errors;
        },
        displayNameErrors() {
            const errors = [];
            if(this.switchForm){
            if (!this.v$.form.displayName.$dirty) return errors;
             this.v$.form.displayName.minLength.$invalid && errors.push(this.$t('register.steps.company.form.displayName.errors.minLength', {count: 6}))
             this.v$.form.displayName.required.$invalid && errors.push(this.$t('register.steps.company.form.displayName.errors.required'))
            }
            return errors;
        },
        companyDocumentErrors() {
            const errors = [];
            this.errors.document.forEach((error) => {
                errors.push(this.$t(error, { doc: this.assets.countries[this.country].companyDocument }))
            })

            if (!this.v$.form.companyDocument.$dirty)
                return errors;
            
            this.v$.form.companyDocument.required.$invalid && errors.push(this.$t('register.steps.company.form.companyDocument.errors.required', {name: this.assets.countries[this.country].companyDocument }))
            if(this.assets.countries[this.country].code == 'PER')
            this.v$.form.companyDocument.validFormat.$invalid && errors.push(this.$t('register.steps.company.form.companyDocument.errors.invalid', {name: this.assets.countries[this.country].companyDocument }));
            return errors;
        },
        phoneErrors() {
            const errors = [];
            if (!this.v$.form.phone.$dirty)
                return errors;
            this.v$.form.phone.required.$invalid && errors.push(this.$t('register.steps.company.form.phone.errors.required'))
            return errors;
        }
    },
    watch: {
        country: {
            immediate: true,
            handler() {
                this.showPhone = false;
                this.form.phone = "";
            }
        },
        'form.companyDocument'(v) {
            this.errors.document = []
            if (!this.v$.form.companyDocument.$invalid) {
                if (this.checkerTimeout.document)
                    clearTimeout(this.checkerTimeout.document)
                this.checkerTimeout.document = setTimeout(() => {
                    this.checker('document', v, 'documentId')
                    this.checkerTimeout.document = null
                }, 1000)
            }
            else {
                this.available.document = null
            }
        },
    },
    methods: {
        prevent(event) {
            event.stopPropagation();
        },
        checker(field, value, toCheck = null) {
            if (!toCheck)
                toCheck = field
            this.checkerLoading[field] = true
            this.$axios.post(`assets/checker/${toCheck}`, { value: value, input: toCheck,country:this.assets.countries[this.country].code, partner: this.$route.params && this.$route.params.p ? this.$route.params.p : null}).then((res) => {
                this.checkerLoading[field] = false
                if (!res.data.data.available) {
                  let key = field == 'document' ? 'companyDocument' : field
                    this.errors[field].push(`register.steps.company.form.${key}.errors.unavailable`)
                }
                this.available[field] = res.data.data.available
            }, err => {
                this.checkerLoading[field] = false
                console.error('ERR', err)
            })
        },
        changeZipCode() {
            this.v$.address.zipCode.$touch();
            if (this.address.zipCode.length == 9 && this.assets.countries[this.country].code == 'BRA') {
              const req = axios.create();
               
                delete req.defaults.headers.common["X-Requested-With"];
                delete req.defaults.headers.common["Access-Control-Allow-Origin"];
                delete req.defaults.headers.common["useCredentails"];
                req
                .get(`https://viacep.com.br/ws/${this.address.zipCode}/json`)
                .then((res) => {
                    this.address.street = res.data.logradouro;
                    this.address.district = res.data.bairro;
                    this.address.city = res.data.localidade;
                    this.address.state = res.data.uf;
                });
            }
            if(this.address.zipCode.length == 5 && this.assets.countries[this.country].code == 'PER'){
                this.$axios.get(`assets/autocomplete/${this.address.zipCode}/pe`).then((response) => {
                  // this.address.street = res.data.logradouro;
                  const res = response.data.data.results.range_codes_details
                  if(res.length){
                    this.address.district = res[0].city;
                    this.address.city = res[0].province;
                    this.address.state = res[0].state_name;
                  }
                },(err) => {
                      console.log(err)
                  })
                }
              

        },
        submit() {
            this.processing = true;
            this.v$.$touch();
            if (!this.v$.$invalid) {
                const AddressForm = {
                    street: this.address.street,
                    city: this.address.city,
                    complement: this.address.complement,
                    country: this.assets.countries[this.country].name,
                    district: this.address.district,
                    default: 1,
                    number: this.address.number,
                    state: this.address.state,
                    zipCode: this.address.zipCode
                }
                const ContactForm = {
                    contact: this.form.phone,
                    text: "",
                    type: 2
                }
                const Form = {
                    address: [AddressForm],
                    contacts: [ContactForm],
                    bankAccount: [],
                    documentType: this.assets.countries[this.country].companyDocument,
                    displayName: this.form.displayNameSS,
                    document: this.form.companyDocument,
                    name: this.form.companyName,
                    tradingName: this.form.displayName,
                    location: this.assets.countries[this.country].code,
                    partner: this.$route.params.p ? this.$route.params.p: null,
                    hasBank: false,
                }
                if(this.$route.query.isWhitelabel){
                  Form.subdomain = `Store-${Math.floor(Math.random() * 9999)}`
                }
                this.$axios.post(`portal/register/company?hash=${this.hash}`, Form).then((response) => {
                    console.log('response', response.data.data.hash)
                    this.$emit('set-hash', {hash: response.data.data.hash, interaction: response.data.data.interaction})
                    this.processing = false
                },(err) => {
                      const error =  err.response.data.errors
                      if(error.length && error[0].hasOwnProperty('timeout')){
                          this.$emit('set-generic-error', 'register.token.expired')
                      }
                      else{
                          console.error('An error found', error)
                      }
                      this.processing = false
                  })
            }
            else {
                this.processing = false;
            }
        }
    },
    // components: { RegisterAddress }
}
</script>